import {
  getAddressSuggestions,
  AddressPrediction,
  getAddressSuggestionsVendor,
} from '../../api/addressApi/addressApi';
// import useSnackBar from '../../hooks/useSnackBar';
import { ErrorData, PaginationQueryParams } from '../../types';
import { AxiosError } from 'axios';

export const addressOptionsQuery = ({ match = '' }: PaginationQueryParams) => {
  if (match.length < 6) {
    return Promise.resolve({ data: { resultSet: [] } });
  }

  return getAddressSuggestions(match)
    .then((response) => {
      return {
        data: {
          resultSet: response.data.predictions || [],
        },
      };
    })
    .catch((error: AxiosError<ErrorData>) => {
      console.error('Error fetching address suggestions:', error.response?.data.message);
      return { data: { resultSet: [] } };
    });
};

// Map address query results to FormAutocompleteField format
export const mapAddressResults = (predictions: AddressPrediction[]) => {
  return predictions.map((prediction) => ({
    id: prediction.placeId,
    label: prediction.description,
    ...prediction,
  }));
};

export const addressOptionsQueryVendor = ({ match = '' }: PaginationQueryParams) => {
  const params = new URLSearchParams(location.search);
  const token = params.get('token');
  if (match.length < 6) {
    return Promise.resolve({ data: { resultSet: [] } });
  }

  return getAddressSuggestionsVendor(match, token as string)
    .then((response) => {
      return {
        data: {
          resultSet: response.data.predictions || [],
        },
      };
    })
    .catch((error: AxiosError<ErrorData>) => {
      console.error('Error fetching address suggestions:', error.response?.data.message);
      return { data: { resultSet: [] } };
    });
};

// Map address query results to FormAutocompleteField format
export const mapAddressResultsVendor = (predictions: AddressPrediction[]) => {
  return predictions.map((prediction) => ({
    id: prediction.placeId,
    label: prediction.description,
    ...prediction,
  }));
};

export const NATIVE_ENTITY_TYPE_MAP: Record<string, string> = {
  FIRM: 'Firm',
  VENDOR_FIRM_PARTICIPATION: 'Vendor',
  CLIENT: 'Plaintiff',
};

const storedAccountingSystem = localStorage.getItem('accountingSystem');
export const accountingVendorType = storedAccountingSystem
  ? {
    NETSUITE: 'NetSuite',
    QUICKBOOKS_ONLINE: 'QuickBooks',
  }[storedAccountingSystem as 'NETSUITE' | 'QUICKBOOKS_ONLINE']
  : null;